<template>
  <section class="prizes prizes--visitor">
    <div v-for="(prize) in getCarouselPrizes" :key="prize.type">
      <div class="prizes__item">
        <div class="prizes__item__wrapper">
          <div class="prizes__item__cont">
            <div class="prizes__item__cont__inner">
              <img v-if="prize.type === 'MONTHLY'" :src="getTranslations.visitor_prizes_monthly_prizes_img" alt="">
              <img v-if="prize.type === 'DAILY'" :src="getTranslations.visitor_prizes_daily_prizes_img" alt="">
              <img v-if="prize.type === 'GRAND'" :src="getTranslations.visitor_prizes_grand_prizes_img" alt="">
              <img v-if="prize.type === 'WEEKLY'" :src="getTranslations.visitor_prizes_weekly_prizes_img" alt="">
            </div>
          </div>
          <div class="prizes__item__cont">
            <div class="prizes__item__cont__inner">
              <div class="monthly" v-if="prize.type === 'MONTHLY'"><h2>{{ getTranslations.visitor_prizes_monthly_prizes }}</h2></div>
              <div class="daily" v-else-if="prize.type === 'DAILY'"><h2>{{ getTranslations.visitor_prizes_daily_prizes }}</h2></div>
              <div class="grand" v-else-if="prize.type === 'GRAND'"><h2>{{ getTranslations.visitor_prizes_grand_prizes }}</h2></div>
              <div class="weekly" v-else-if="prize.type === 'WEEKLY'"><h2>{{ getTranslations.visitor_prizes_weekly_prizes }}</h2></div>
              <!--<p>{{ prize.description }}</p>-->
              <!--<p>{{ prize.headline }}</p>-->
              <div class="monthly" v-if="prize.type === 'MONTHLY'"><p>{{ prize.banner }}</p></div>
              <div class="daily" v-else-if="prize.type === 'DAILY'"><p>{{ prize.banner }}</p></div>
              <div class="grand" v-else-if="prize.type === 'GRAND'"><p>{{ prize.banner }}</p></div>
              <div class="weekly" v-else-if="prize.type === 'WEEKLY'"><p>{{ prize.banner }}</p></div>

            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'prizes',
  computed: {
    ...mapGetters('i18n', [
      'getTranslations',
    ]),
    ...mapGetters('profile', [
      'getCarouselPrizes',
    ]),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/visitor/Prizes.vue